WiseMetering.Views.V2CIntegrationsTable = WiseMetering.Views.TableIndex.extend({
    icon: 'integrations',
    name: () => 'v2c',

    createTable: function() {
        this.collection = this.model.integrations();

        this.table = new WiseMetering.Views.Table({
            id: 'integrations',
            collection: this.collection,
            modelSerializer: model => {
                let
                    color = 'orange',
                    state = model.get('state');

                if (state === 'active') {
                    color = 'green';
                }

                return {
                    siteName: model.site().get('name'),
                    configurationName: model.configuration().get('name'),
                    id: model.id,
                    indicatorKind: model.indicatorKind().get('name'),
                    name: model.get('name'),
                    ratio: model.get('ratio'),
                    reference: model.get('reference'),
                    lastRunAt: model.get('last_run_at') ? WiseMetering.utils.formatDate(model.get('last_run_at')) : '-',
                    updatedAt: WiseMetering.utils.formatDate(model.get('updated_at')),
                    state: { color, state }
                };
            },
            columns: {
                state: {
                    mRender: ({ color, state }) => JST['templates/ui/components/circle']({
                        color: WiseMetering.SemaphorColors[color],
                        title: state.capitalize()
                    }),
                    sWidth: '20px'
                },
                configurationName: i18next.t('glossary.configuration'),
                name: i18next.t('common.name'),
                siteName: i18next.t('glossary.site'),
                indicatorKind: i18next.t('glossary.indicator_kind'),
                ratio: i18next.t('glossary.ratio'),
                reference: i18next.t('integrations.reference'),
                lastRunAt: i18next.t('integrations.last_run_at'),
                updatedAt: i18next.t('glossary.last_change')
            },
            toolbar_actions: {
                new: {
                    label: i18next.t('ui.actions.new'),
                    view_call: () => new WiseMetering.Views.NewV2CIntegration({
                        collection: WiseMetering.integrations,
                        license: this.model,
                        model: new WiseMetering.Model.Integration({ license_id: this.model.id })
                    })
                },
                edit: {
                    label: i18next.t('ui.actions.edit'),
                    view_call: model => new WiseMetering.Views.EditV2CIntegration({ model })
                },
                show: {
                    label: i18next.t('ui.actions.show'),
                    view_call: model => new WiseMetering.Views.ShowV2CIntegration({ model })
                },
                rebuild: {
                    permission: 'superuser',
                    icon: 'rebuild',
                    label: i18next.t('ui.actions.rebuild'),
                    view_call: model => new WiseMetering.Views.RebuildIntegration({ model })
                },
                disable: {
                    icon: 'disable',
                    label: i18next.t('ui.actions.disable'),
                    view_call: model => {
                        if (model.get('state') !== 'active') {
                            return;
                        }

                        new WiseMetering.Views.DisableIntegration({ model });
                    }
                },
                enable: {
                    icon: 'enable',
                    label: i18next.t('ui.actions.enable'),
                    view_call: model => {
                        if (model.get('state') === 'active') {
                            return;
                        }

                        new WiseMetering.Views.EnableIntegration({ model });
                    }
                },
                delete: {
                    permission: 'superuser',
                    view_call: model => new WiseMetering.Views.Modal.DestroyExtraConfirmation({
                        model,
                        title: () => i18next.t('modal.title.integrations.destroy')
                    })
                }
            }
        });

        $(this.body.el).html(this.table.el);
    },

    onClose: function() {
        this.stopListening(WiseMetering.integrations);

        if (this.table && this.table.remove && typeof (this.table.remove) === 'function') {
            this.table.remove();
        }
    },

    onShow: function() {
        this.listenTo(WiseMetering.integrations, 'remove add change', this.createTable.bind(this));

        this.createTable();
    }
});
